import type { SiteLanguage } from "@/utils/routing";
import { SK_WORLDS, type WorldsContent } from "./worldsContent";
import { DA_WORLDS } from "./da/daWorlds";
import { CS_WORLDS } from "./cs/csWorlds";
import { EN_WORLDS } from "./en/enWorlds";
import { DE_WORLDS } from "./de/worldsContent";

/** One entry per language that has its own home-page crew and doors. */
const WORLDS: Partial<Record<SiteLanguage, WorldsContent>> = {
  sk: SK_WORLDS,
  da: DA_WORLDS,
  cs: CS_WORLDS,
  en: EN_WORLDS,
  de: DE_WORLDS,
};

/** The crew and doors for a language, or null where none is written yet. */
export function getWorldsContent(lang: string): WorldsContent | null {
  return WORLDS[lang as SiteLanguage] ?? null;
}
